import jsBridge from './utils/bridge.mjs';
import { API_GET_ORDER_INFO, API_SHOW_THIRD_PAY_LOADING, API_NOTIFY_PAY_SUCCESS, API_NOTIFY_PAY_PENDING, API_NOTIFY_PAY_FAILED, API_NOTIFY_PAY_START, API_GET_PAYPAL_MAGNES_RESULT, API_CHECK_APPLE_PAY, API_CHECK_GOOGLE_PAY, API_REQUEST_APPLE_PAY, API_REQUEST_GOOGLE_PAY, EVENT_APPLE_PAY_RESULT, EVENT_GOOGLE_PAY_RESULT } from './utils/constant.mjs';
/**
 * 支付渠道 id
 */
export var PaymentChannelId;
(function (PaymentChannelId) {
    PaymentChannelId[PaymentChannelId["Unknown"] = 0] = "Unknown";
    PaymentChannelId[PaymentChannelId["Card"] = 1] = "Card";
    PaymentChannelId[PaymentChannelId["Paypal"] = 2] = "Paypal";
    PaymentChannelId[PaymentChannelId["Klarna"] = 3] = "Klarna";
    PaymentChannelId[PaymentChannelId["PayIn4"] = 4] = "PayIn4";
    PaymentChannelId[PaymentChannelId["PayLater"] = 5] = "PayLater";
    PaymentChannelId[PaymentChannelId["PayIn4x"] = 6] = "PayIn4x";
    PaymentChannelId[PaymentChannelId["PayLaterInGermany"] = 7] = "PayLaterInGermany";
})(PaymentChannelId || (PaymentChannelId = {}));
/**
 * 客户端定义的第三方支付渠道标识
 */
export var ThirdPayType;
(function (ThirdPayType) {
    ThirdPayType[ThirdPayType["Paypal"] = 1] = "Paypal";
    ThirdPayType[ThirdPayType["PayLater"] = 2] = "PayLater";
    ThirdPayType[ThirdPayType["Klarna"] = 3] = "Klarna";
    ThirdPayType[ThirdPayType["Pacypay"] = 4] = "Pacypay";
    ThirdPayType[ThirdPayType["Other"] = 5] = "Other"; // 通用样式
})(ThirdPayType || (ThirdPayType = {}));
/**
 * 支付渠道标识和客户端定义的第三方支付类型映射
 */
export const thirdPayTypeMap = {
    [PaymentChannelId.Paypal]: ThirdPayType.Paypal,
    [PaymentChannelId.PayIn4]: ThirdPayType.PayLater,
    [PaymentChannelId.PayLater]: ThirdPayType.PayLater,
    [PaymentChannelId.PayIn4x]: ThirdPayType.PayLater,
    [PaymentChannelId.PayLaterInGermany]: ThirdPayType.PayLater,
    [PaymentChannelId.Klarna]: ThirdPayType.Klarna
};
/**
 * 显示第三方支付 loading
 * @param params
 * @returns
 */
export function showThirdPayLoading(params) {
    return jsBridge.callPromise({
        minVersion: '1.0.1',
        noResponse: true
    }, API_SHOW_THIRD_PAY_LOADING, params);
}
/**
 * 获取订单信息
 * @param params
 * @returns
 */
export function getOrderInfo(params = {}) {
    return jsBridge.callPromise('', API_GET_ORDER_INFO, params);
}
/**
 * 通知客户端支付成功
 * @returns
 */
export function notifyPaySuccess(params = {}) {
    return jsBridge.callPromise({
        noResponse: true
    }, API_NOTIFY_PAY_SUCCESS, params);
}
/**
 * 通知客户端支付待确认
 * @returns
 */
export function notifyPayPending(params = {}) {
    return jsBridge.callPromise({
        noResponse: true
    }, API_NOTIFY_PAY_PENDING, params);
}
/**
 * 通知客户端支付失败
 * @returns
 */
export function notifyPayFailed(params = {}) {
    return jsBridge.callPromise({
        noResponse: true
    }, API_NOTIFY_PAY_FAILED, params);
}
/**
 * 开始支付事件
 * @param params
 * @returns
 */
export function notifyPayStart(params) {
    return jsBridge.callPromise({
        noResponse: true
    }, API_NOTIFY_PAY_START, params);
}
/**
 * 获取 paypal 免密支付结果
 * @param params
 * @returns
 */
export function getPaypalMagnesResult(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.0.6'
    }, API_GET_PAYPAL_MAGNES_RESULT, params);
}
/**
 * 检查是否支持 apple pay
 * @param params
 */
export function checkApplePay(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.0.0'
    }, API_CHECK_APPLE_PAY, params);
}
/**
 * 检查是否支持 google pay
 * @param params
 */
export function checkGooglePay(params) {
    return jsBridge.callPromise({
        minVersion: '1.1.0'
    }, API_CHECK_GOOGLE_PAY, params);
}
let applePayInited = false;
let latestApplePayResolve;
/**
 * 请求 apple pay
 * @param params
 * @returns
 */
export function requestApplePay(params) {
    if (!applePayInited) {
        applePayInited = true;
        jsBridge.addEventListener(EVENT_APPLE_PAY_RESULT, (res) => {
            if (latestApplePayResolve) {
                latestApplePayResolve({
                    data: res,
                    error: null
                });
                latestApplePayResolve = null;
            }
        });
    }
    return new Promise((resolve) => {
        jsBridge
            .callPromise({
            minVersion: '1.0.0'
        }, API_REQUEST_APPLE_PAY, params)
            .then((res) => {
            if (res.error) {
                resolve(res);
            }
            else {
                latestApplePayResolve = resolve;
            }
        });
    });
}
let googlePayInited = false;
let latestGooglePayResolve;
/**
 * 请求 google pay
 * @param params
 * @returns
 */
export function requestGooglePay(params) {
    if (!googlePayInited) {
        googlePayInited = true;
        jsBridge.addEventListener(EVENT_GOOGLE_PAY_RESULT, (res) => {
            if (latestGooglePayResolve) {
                latestGooglePayResolve({
                    data: res,
                    error: null
                });
                latestGooglePayResolve = null;
            }
        });
    }
    return new Promise((resolve) => {
        jsBridge
            .callPromise({
            minVersion: '1.1.0'
        }, API_REQUEST_GOOGLE_PAY, params)
            .then((res) => {
            if (res.error) {
                resolve(res);
            }
            else {
                latestGooglePayResolve = resolve;
            }
        });
    });
}
